<template>
    <div class="flex-1 flex flex-col">
        <article>
            <router-view
                v-slot="{ Component }"
                name="modal"
                :key="$route.params.time"
            >
                <component :is="Component"></component>
            </router-view>

            <roles v-if="modal == 'groups'" :role="modal"></roles>
            <roles v-if="modal == 'members'" :role="modal"></roles>

            <main
                class="flex overflow-y-auto focus:outline-none mb-12 h-screen"
            >
                <router-view
                    v-slot="{ Component }"
                    name="tab"
                    class="pt-4"
                    :key="$route.params"
                >
                    <transition name="fade" mode="out-in">
                        <component :is="Component"></component>
                    </transition>
                </router-view>
            </main>
        </article>
    </div>
</template>

<script>
export default {
    mounted() {
        Eventing.listen("openRolesModal", (role) => (this.modal = role));
        Eventing.listen("closeModal", () => (this.modal = false));
    },
    data() {
        return {
            show: false,
            modal: false,
        };
    },
};
</script>
